import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import {
  showCredentialDialog,
  hideCredentialDialog,
} from '../store/actions/credentialDialog.actions';

export const useCredentialDialog = () => {
  const dispatch = useDispatch();
  const savedResult = useSelector((state) => state.credentialDialog.savedResult);
  const dialogs = useSelector((state) => state.credentialDialog.dialogs);
  const pendingRequests = useRef(new Map());

  useEffect(() => {
    if (!savedResult) return;
    const onSaved = pendingRequests.current.get(savedResult.requestId);
    pendingRequests.current.delete(savedResult.requestId);
    onSaved?.(savedResult.credential);
  }, [savedResult]);

  useEffect(() => {
    const activeRequests = new Set(dialogs.map((dialog) => dialog.requestId));
    pendingRequests.current.forEach((_, requestId) => {
      if (!activeRequests.has(requestId)) pendingRequests.current.delete(requestId);
    });
  }, [dialogs]);

  const openCredentialDialog = useCallback(
    (options = {}) => {
      const { onSaved, ...dialogOptions } = options;
      const requestId = uuid();
      pendingRequests.current.set(requestId, onSaved);
      dispatch(showCredentialDialog({ ...dialogOptions, requestId }));
      return requestId;
    },
    [dispatch]
  );

  const closeCredentialDialog = useCallback(
    (requestId) => {
      pendingRequests.current.delete(requestId);
      dispatch(hideCredentialDialog(requestId));
    },
    [dispatch]
  );
  return { openCredentialDialog, closeCredentialDialog };
};
